export default {
  INSERT_INTO_ALL: "INSERT_INTO_ALL_COMPANY",
  ADD_TO_IN_PROGRESS: "ADD_TO_IN_PROGRESS_COMPANY",
  INSERT_INTO_FORMS: "INSERT_INTO_FORMS_COMPANY",
  DESTROY_FORM: "DESTROY_FORM_COMPANY",
  SET_FORM_ERROR: "SET_FORM_ERROR_COMPANY",
  UPDATE_FORM_INSTANCE: "UPDATE_FORM_INSTANCE_COMPANY",
  INSERT_INTO_PAGINATION: "INSERT_INTO_PAGINATION_COMPANY",
  INSERT_INTO_FILTERED: "INSERT_INTO_FILTERED_COMPANY",
  RESET_STATE: "RESET_STATE_COMPANY",
  CLEAR_FETCHED: "CLEAR_FETCHED_COMPANY",
  REMOVE_FROM_IN_PROGRESS: "REMOVE_FROM_IN_PROGRESS_COMPANY",
  SET_ASK_DELETE_DATA: "SET_ASK_DELETE_DATA_COMPANY",

  LIST_URL: "/standard/toplevel/company/list/",
  POST_URL: "/standard/toplevel/company/",
  PATCH_URL: "/standard/toplevel/company/",
  GET_URL: "/standard/toplevel/company/",

  STORE_NAME: "companies",
};
